import { matchPath } from 'react-router';
import { IRoute } from '../routes/routes';
import { useEffect, useState } from 'react';

export const useRouteParams = <T extends {}>(route: IRoute) => {
  const [params, setParams] = useState<T>();

  useEffect(() => {
    const data = matchPath(window.location.pathname, {
      path: route.path,
      exact: true
    });
    setParams(data?.params as any || '');
  }, [route]);

  return { params } as any;
};